export const enum ReferralUserType {
  NEW = "NEW",
  REFERRED = "ALREADY_REFERRED",
  KOL = "KOL",
}
